// TODO:

import { ReactNode, createContext } from 'react';

// CanvasContext should accept the CanvasProps,
// Accessible from useContext(CanvasContext)

export interface CanvasProps {
  theme?: string
  isXrayMode?: boolean
  scale?: number
  children?: ReactNode
}

export const CanvasContext = createContext<Omit<CanvasProps, 'children'>>({
  scale: 1,
});
